(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qyntraa-quote-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qyntraa-gallery')) {
    class QyntraaGallery extends HTMLElement {
      constructor() {
        super();
        this.handleControl = this.handleControl.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleControl);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleControl);
      }

      handleControl(event) {
        const button = event.target.closest('[data-gallery-direction]');
        const track = this.querySelector('[data-gallery-track]');
        if (!button || !track || !this.contains(button)) return;

        const direction = button.dataset.galleryDirection === 'next' ? 1 : -1;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior });
      }
    }

    customElements.define('qyntraa-gallery', QyntraaGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
